var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "full-height qrcode-viewer" }, [
    _c("br"),
    _c("br"),
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _c("div", { staticClass: "qrcode-container" }, [
      _c(
        "div",
        { class: "qrcode-inner" },
        [
          _c("LoadingMini", { ref: "loading" }),
          _vm._v(" "),
          _c("QRCode", {
            ref: "qrcode",
            class: { show: _vm.code != "" },
            attrs: {
              text: _vm.code,
              size: 300,
              color: "#000000",
              "bg-color": "#FFFFFF",
              "error-level": "M",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false",
          },
        ],
        staticClass: "form-row row standard",
      },
      [
        _c("div", { staticClass: "col-12 simple-checkbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.insertComment,
                expression: "insertComment",
              },
            ],
            attrs: {
              type: "checkbox",
              name: "qrcodeComment",
              id: "qrcodeComment",
            },
            domProps: {
              checked: Array.isArray(_vm.insertComment)
                ? _vm._i(_vm.insertComment, null) > -1
                : _vm.insertComment,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.insertComment,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.insertComment = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.insertComment = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.insertComment = $$c
                  }
                },
                _vm.toggleComment,
              ],
            },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "qrcodeComment" } }, [
            _vm._v(_vm._s(_vm.$t("ap.qrcodeComment"))),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("br", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hasComment,
          expression: "!hasComment",
        },
      ],
    }),
    _c("br"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "center" },
      [
        _c(
          "Btn",
          {
            directives: [
              {
                name: "can",
                rawName: "v-can",
                value: "beepiz-downloadQRCode-library",
                expression: "'beepiz-downloadQRCode-library'",
              },
            ],
            staticClass: "primary reverse",
            nativeOn: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.handleDownload($event)
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("ap.qrcodeDownload")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }